/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Mini_TInputs */

const en_tut_mini_t = /** @type {(inputs: Tut_Mini_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mini Mode: the office in a small window`)
};

const id_tut_mini_t = /** @type {(inputs: Tut_Mini_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mini Mode: kantor di jendela kecil`)
};

/**
* | output |
* | --- |
* | "Mini Mode: the office in a small window" |
*
* @param {Tut_Mini_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_mini_t = /** @type {((inputs?: Tut_Mini_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Mini_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_mini_t(inputs)
	return en_tut_mini_t(inputs)
});